import ReactGA from 'react-ga';

export const initialzeGoogleAnalytics = () => {
  if (process.env.NODE_ENV === 'development') {
    ReactGA.event = (eventData) => {
      console.log('Mock ReactGA.event:', eventData);
    };
    return;
  }
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_UNIQUE_ID);
};

export const sendWebsiteOpenedEvent = (token) => {
  if (token == null) token = "-1";
  ReactGA.event({
    category: 'User',
    action: 'Website Opened',
    label: token
  });
};

export const sendLoadBaseMapEvent = (token, baseMap) => {
  if (token == null) token = "-1";
  ReactGA.event({
    category: 'Map page',
    action: `${baseMap} map loading`,
    label: token,
  });
};

export const sendBaseMapLoadedSuccessEvent = (token, baseMap, timeTaken) => {
  if (token == null) token = "-1";
  timeTaken = Math.round(timeTaken);
  ReactGA.event({
    category: 'Map page',
    action: `${baseMap} map load success`,
    label: `${token} | ${timeTaken}ms`
  });
};

export const sendBaseMapLoadedFailureEvent = (token, baseMap, error) => {
  if (token == null) token = "-1";
  ReactGA.event({
    category: 'Map page',
    action: `${baseMap} map load failed with error: ${error}`,
    label: token
  });
};

